import React from 'react';
import { Fragment } from 'react';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Header from '../../../components/headerlogged';
import Componentes from '../../../components/user/componentes/listar/editar';


function EditComponentesScreen () {
    return (
        <Fragment>
            <Head titulo="Edição de Componentes | Departamento de TI" />
            <Header />
            <Componentes />
            <Footer />
        </Fragment>
    );
}

export default EditComponentesScreen;